import React from 'react'
import './Tooltip.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons/faInfoCircle'

export interface ITooltipProps {
  children: React.ReactNode
}

const Tooltip = (props: ITooltipProps) => {
  return (
    <span className="tooltip">
      <FontAwesomeIcon
        title={props.children.toString()}
        tabIndex={0}
        icon={faInfoCircle}
        data-tip
      />
      <span
        className="tooltip-text"
        style={{ whiteSpace: 'pre-line' }}
        role="tooltip"
      >
        {props.children}
      </span>
    </span>
  )
}

export default Tooltip
